export default {
  title: 'Ønsker du å slette dette albumet?',
  text: 'Dette kan ikke angres og albumet og alle bildene i det blir slettet for alltid.',
  deny: 'Behold albumet',
  confirm: 'Slett albumet',
};
